export default "__VITE_ASSET__CLwSDe0b__"